import circleRedWhite from "../../../assets/circleRedWhite.png";
import { Map } from "mapbox-gl";
import { RouteState } from "../../../api/edits/editRoute.responses";
import {
  MapBoxGLMultiPolygon,
  MapBoxGLPoint,
  MapBoxGLPointData,
} from "../../../ts/interfaces/mapbox.interfaces";
import { CreateCirclePolygon } from "./Mappanel.part.ts";

// pre:   - route has the route with focused sounds
//        - map has mapbox object on which to display
// post:  - map layer pois has updated data
export function UpdatePois(map: Map, route: RouteState): void {
  if (map != null) {
    let lay: any = map.getSource("points_POIs_source");
    if (lay !== undefined) {
      lay.setData(FillDataForPOIs(route));
    }

    const polygons: number[][][][] = route.pointsOfInterest.map((poi) =>
      [CreateCirclePolygon([poi.longitude, poi.latitude], poi.radius)]
    );
    const layPoly: any = map.getSource("poi_polygon");
    if (layPoly !== undefined) {
      const geojson: MapBoxGLMultiPolygon = {
        type: "Feature",
        geometry: { type: "MultiPolygon", coordinates: polygons },
      };
      layPoly.setData(geojson);
    }
  }
}
// pre:   route object with POI sounds from which data is created
// post:  returns array data with coordinates of POI sounds
export function FillDataForPOIs(route: RouteState): MapBoxGLPointData {
  let data: MapBoxGLPointData = {
    type: "FeatureCollection",
    features: [],
  };
  // loop through array of points
  for (let i: number = 0; i < route.pointsOfInterest.length; ++i) {
    let point: MapBoxGLPoint = {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          // add geometry from route object
          route.pointsOfInterest[i].longitude,
          route.pointsOfInterest[i].latitude,
        ],
      },
      properties: {
        // add name
        title: String(route.pointsOfInterest[i].id),
        order: route.pointsOfInterest[i].pointOrder,
      },
    };
    data.features.push(point);
  }
  return data;
}

// pre:   - route has the route with POI sounds
//        - map has mapbox object on which to display
// post:  - map with displayed POI sounds
export function DisplayRoutePOIs(map: Map, route: RouteState): void {
  map.on("load", () => {
    // Add an image to use as a custom marker
    map.loadImage(circleRedWhite, (error, image) => {
      if (error) throw error;
      map.addImage("circle", image as ImageBitmap);
      // Add a GeoJSON point source
      map.addSource("points_POIs_source", {
        type: "geojson",
        data: FillDataForPOIs(route) as any,
      });
      // Add a symbol layer
      map.addLayer({
        id: "points_POIs",
        type: "symbol",
        source: "points_POIs_source",
        layout: {
          "icon-image": "circle",
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "text-allow-overlap": true,
          "text-optional": true,
          "text-field": ["get", "order"],
          "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
          "text-offset": [0, 0],
          "text-anchor": "center",
        },
      });
    });

    const polygons: number[][][][] = route.pointsOfInterest.map((poi) =>
      [CreateCirclePolygon([poi.longitude, poi.latitude], poi.radius)]
    );
    map.addSource("poi_polygon", {
      type: "geojson",
      data: {
        type: "Feature",
        geometry: { type: "MultiPolygon", coordinates: polygons },
      } as any,
    });
    map.addLayer({
      id: "poi_fill",
      type: "fill",
      source: "poi_polygon",
      layout: {},
      paint: { "fill-color": "#e67a7a", "fill-opacity": 0.15 },
    });
    map.addLayer({
      id: "poi_line",
      type: "line",
      source: "poi_polygon",
      layout: {},
      paint: { "line-color": "#961919", "line-width": 1 },
    });
  });
}
